import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { RouterLinkActive, RouterModule } from '@angular/router'
import { SharedModule } from 'lib-trend-core'
import { BaseComponent } from './base/base.component'
import { HeaderComponent } from './header.component'
import { SideBarComponent } from './sidebar.component'

@NgModule({ declarations: [BaseComponent, HeaderComponent, SideBarComponent],
    exports: [BaseComponent, HeaderComponent, SideBarComponent], imports: [CommonModule,
        RouterModule,
        SharedModule,
        RouterLinkActive], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class LayoutModule {}
